import React from "react";
import { Link } from "react-router-dom";
import "./Services.css";

const Services = () => {
  return (
    <div id="service" className="services-section-bg-color padding-top-bottom">
      <div className="padding-sides">
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="functions-header-size text-center">Our Functions</div>
            <div className="header-sub-text text-center pb-5">
              We are a modern software development group that makes cloud native
              applications, specializing in React.js & React Native.
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container" data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/web.png"
                  srcSet="../../../images/logos/services/logoSizes/web2.png 2x, i../../../images/logos/services/logoSizes/web3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  Web
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container" data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/ux.png"
                  srcSet="../../../images/logos/services/logoSizes/ux2.png 2x, i../../../images/logos/services/logoSizes/ux3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  UX
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container " data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/devops.png"
                  srcSet="../../../images/logos/services/logoSizes/devops2.png 2x, i../../../images/logos/services/logoSizes/devops3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  DevOps
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container " data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/mobile.png"
                  srcSet="../../../images/logos/services/logoSizes/mobile2.png 2x, i../../../images/logos/services/logoSizes/mobile3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  Mobile
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container " data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/ui.png"
                  srcSet="../../../images/logos/services/logoSizes/ui2.png 2x, i../../../images/logos/services/logoSizes/ui3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  UI
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-md-12 col-xs-12">
            <div className="function-box-content-container " data-aos="flip-up">
              <a id="hyperlink-text-black" href="/services">
                <img
                  className="display-inline-block icon-size-position"
                  src="../../../images/logos/services/logoSizes/qa.png"
                  srcSet="../../../images/logos/services/logoSizes/qa2.png 2x, i../../../images/logos/services/logoSizes/qa3.png 3x"
                />
                <div className="display-inline-block function-text-size">
                  QA
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <div id="button-color-size" className="text-center mt-5 mx-auto">
            <a id="hyperlink-text" href="/services">
              View Details
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/Mainpage/Services/Services.js